import { Box, Switch, Typography } from '@mui/material';

type SwitchWithLabelsProps = {
    value: boolean;
    onChange: (value: boolean) => void;
    labelBefore?: string;
    labelAfter?: string;
    disabled?: boolean;
};

const SwitchWithLabels = ({
    value,
    onChange,
    labelBefore,
    labelAfter,
    disabled = false,
}: SwitchWithLabelsProps) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {labelBefore && (
                <Typography sx={(theme) => ({ marginRight: '8px', color: value ? '#636363' : theme.palette.primary.main })}>
                    {labelBefore}
                </Typography>
            )}
            <Switch
                color='primary'
                checked={value}
                onChange={({ target }) => onChange(target.checked)}
                disabled={disabled}
            />
            {labelAfter && (
                <Typography sx={(theme) => ({ marginRight: '8px', color: !value ? '#636363' : theme.palette.primary.main })}>
                    {labelAfter}
                </Typography>
            )}
        </Box>
    );
}

export default SwitchWithLabels;
